/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Non_ForcedInputs */

const en_editor_filter_non_forced = /** @type {(inputs: Editor_Filter_Non_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Forced`)
};

const fr_editor_filter_non_forced = /** @type {(inputs: Editor_Filter_Non_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non forcé`)
};

const de_editor_filter_non_forced = /** @type {(inputs: Editor_Filter_Non_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht erzwungen`)
};

const it_editor_filter_non_forced = /** @type {(inputs: Editor_Filter_Non_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non forzato`)
};

const ru_editor_filter_non_forced = /** @type {(inputs: Editor_Filter_Non_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непринудительные`)
};

const es_editor_filter_non_forced = /** @type {(inputs: Editor_Filter_Non_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No forzado`)
};

const zh_cn2_editor_filter_non_forced = /** @type {(inputs: Editor_Filter_Non_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非强制`)
};

const ja_editor_filter_non_forced = /** @type {(inputs: Editor_Filter_Non_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非強制`)
};

const hi_editor_filter_non_forced = /** @type {(inputs: Editor_Filter_Non_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गैर-बाध्य`)
};

const pt_pt2_editor_filter_non_forced = /** @type {(inputs: Editor_Filter_Non_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não Forçado`)
};

/**
* | output |
* | --- |
* | "Non-Forced" |
*
* @param {Editor_Filter_Non_ForcedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_non_forced = /** @type {((inputs?: Editor_Filter_Non_ForcedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Non_ForcedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_non_forced(inputs)
	if (locale === "de") return de_editor_filter_non_forced(inputs)
	if (locale === "it") return it_editor_filter_non_forced(inputs)
	if (locale === "ru") return ru_editor_filter_non_forced(inputs)
	if (locale === "es") return es_editor_filter_non_forced(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_non_forced(inputs)
	if (locale === "ja") return ja_editor_filter_non_forced(inputs)
	if (locale === "hi") return hi_editor_filter_non_forced(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_non_forced(inputs)
	return en_editor_filter_non_forced(inputs)
});